import { z } from 'zod'

export const LoginEvent = z.object({
  timestamp: z.string(),
  ip: z.string(),
  protocol: z.string(),
  success: z.boolean(),
  user_agent: z.string().optional(),
  country: z.string().optional()
})

export type LoginEvent = z.infer<typeof LoginEvent>

export const LoginHistoryResponse = z.object({
  events: z.array(LoginEvent),
  total: z.number().optional()
})

export type LoginHistoryResponse = z.infer<typeof LoginHistoryResponse>
